export default "__VITE_ASSET__D3NFn96p__"